import { CButton } from 'app/components/Common'
import { COLORS } from 'app/constants'
import React, { useState } from 'react'
import { View } from 'styles/reactnative'
import PopUpUpdateModal from './PopUpUpdateModal'

const PopUpUpdate = ({ data }) => {
	const [showModal, setShowModal] = useState(false)
	return (
		<View>
			<CButton
				title={'수정'}
				style={{
					background: COLORS.primary,
					color: COLORS.white,
					paddingBlock: 5,
					paddingInline: 15,
					whiteSpace: 'nowrap',
					alignSelf: 'flex-end',
				}}
				onClick={() => setShowModal(!showModal)}
			/>
			<PopUpUpdateModal
				data={data}
				showModal={showModal}
				setShowModal={setShowModal}
			/>
		</View>
	)
}

export default PopUpUpdate
